// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabs_tab__2vydL"};